import { render, staticRenderFns } from "./ShopsAddShopForm.vue?vue&type=template&id=4bc87540&"
import script from "./ShopsAddShopForm.vue?vue&type=script&lang=js&"
export * from "./ShopsAddShopForm.vue?vue&type=script&lang=js&"
import style0 from "./ShopsAddShopForm.vue?vue&type=style&index=0&id=4bc87540&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports